module.exports = __webpack_public_path__ + "static/media/doubleBed.f59264bc.svg";